import type { SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useWPApi } from "@gik/core/api/swr/useWPApi";
import type WordpressTag from "@gik/core/models/wordpress/WordpressTag";

const path = "content_tag";

export interface ContentTagParams {
	_fields?: string[];
}

export function getContentTags(params?: ContentTagParams) {
	return wpApi.get(path, {
		searchParams: {
			"proxy-cms-pages": "all",
			...(params?._fields?.length > 0
				? { _fields: params._fields.join(",") }
				: {}),
		},
	});
}

export function useContentTags(
	params?: ContentTagParams,
	config?: SWRConfigInterface,
) {
	return useWPApi<WordpressTag[]>(
		path,
		{
			"proxy-cms-pages": "all",
			...(params?._fields?.length > 0
				? { _fields: params._fields.join(",") }
				: {}),
		},
		config,
	);
}
